import React from "react"
import { MDXProvider } from "@mdx-js/react"
import {
  Slideshow,
  SliderItem,
  SliderItemContent,
} from "../components/MdxShortCodes/slider"
import { ProductHeader } from "../components/MdxShortCodes/product-header"
import AboutBody from "../components/about/AboutBody"
import { mkText } from "../components/MdxShortCodes/text"
import Image from "../components/MdxShortCodes/Image"
import HoverShadow from "../components/MdxShortCodes/HoverShadow"
import {
  GridText,
  GridTextContainer,
} from "../components/MdxShortCodes/GridText"
import Section, { SimpleSection } from "../components/MdxShortCodes/Section"
import { BookDemo as BookDemoForm } from "../components/bookDemo/BookDemo"
import { ButtonLink } from "../components/MdxShortCodes/ButtonLink"
import { XpressOn } from "../components/MdxShortCodes/XpressOn"
import { Video } from "../components/video/Video"
import { Card } from "../components/MdxShortCodes/Card"
import { Accordion, AccordionItem } from "../components/MdxShortCodes/Accordion"
import loadable from "@loadable/component"
import { Iframe } from "../components/MdxShortCodes/Iframe"
import { MDXComponents } from "mdx/types.js"

import Content from "../components/MdxShortCodes/new-mdxShortCodes/Content/Content"
import Section_ from "../components/MdxShortCodes/new-mdxShortCodes/Section/Section"
import Button from "../components/MdxShortCodes/new-mdxShortCodes/Button/Button"
import Text_ from "../components/MdxShortCodes/new-mdxShortCodes/Text/Text"
import Float from "../components/MdxShortCodes/new-mdxShortCodes/Float/Float"
import CircleMenu from "../components/MdxShortCodes/new-mdxShortCodes/CircleMenu/CircleMenu"
import Boxes from "../components/MdxShortCodes/new-mdxShortCodes/Boxes/Boxes"
import Lists from "../components/MdxShortCodes/new-mdxShortCodes/Lists/Lists"
import SpeechBabble from "../components/MdxShortCodes/new-mdxShortCodes/SpeechBabble/SpeechBabble"
import ScrollX from "../components/MdxShortCodes/new-mdxShortCodes/ScrollX/ScrollX"
import MoreText from "../components/MdxShortCodes/new-mdxShortCodes/MoreText/MoreText"
import WidgetRightPicture from "../components/MdxShortCodes/new-mdxShortCodes/WidgetRightPicture"
import WidgetLeftPicture from "../components/MdxShortCodes/new-mdxShortCodes/WidgetLeftPicture"
import WidgetCenterText from "../components/MdxShortCodes/new-mdxShortCodes/WidgetCenterText"
import TouchpointIcons from "../components/MdxShortCodes/new-mdxShortCodes/TouchpointIcons"
import FeatureList from "../components/MdxShortCodes/new-mdxShortCodes/FeatureList"
import WidgetRightElement from "../components/MdxShortCodes/new-mdxShortCodes/WidgetRightElement"
import WidgetLeftElement from "../components/MdxShortCodes/new-mdxShortCodes/WidgetLeftElement"
import WidgetCards from "../components/MdxShortCodes/new-mdxShortCodes/WidgetCards"
import WidgetLists from "../components/MdxShortCodes/new-mdxShortCodes/WidgetLists"
import TerminalSmilies from "../components/MdxShortCodes/new-mdxShortCodes/TerminalSmilies"
import PreviewBlog from "../components/MdxShortCodes/new-mdxShortCodes/PreviewBlog/PreviewBlog"
import WidgetCenterPicture from "../components/MdxShortCodes/new-mdxShortCodes/WidgetCenterPicture"
import FeatureCategories from "../components/MdxShortCodes/new-mdxShortCodes/FeatureCategories/FeatureCategories"
import YouTubeVideo from "../components/MdxShortCodes/new-mdxShortCodes/YouTubeVideo"
import WidgetCenterElement from "../components/MdxShortCodes/new-mdxShortCodes/WidgetCenterElement"
import Laptop from "../components/MdxShortCodes/new-mdxShortCodes/Laptop/Laptop"
import RotatingMenu from "../components/MdxShortCodes/new-mdxShortCodes/RotatingMenu/RotatingMenu"
import PreviewSolution from "../components/MdxShortCodes/new-mdxShortCodes/PreviewSolution/PreviewSolution"
import ScrollableGallery from "../components/MdxShortCodes/new-mdxShortCodes/ScrollableGallery/ScrollableGallery"
import EmployeeIcons from "../components/MdxShortCodes/new-mdxShortCodes/EmployeeIcons/EmployeeIcons"
import ScrollToId from "../components/MdxShortCodes/new-mdxShortCodes/ScrollToId"
import Card_ from "../components/MdxShortCodes/new-mdxShortCodes/Card/Card"
import SwipeableScrolling from "../components/MdxShortCodes/new-mdxShortCodes/SwipeableScrolling/SwipeableScrolling"
import DropdownGallery from "../components/MdxShortCodes/new-mdxShortCodes/DropdownGallery/DropdownGallery"

const ContactForm = loadable(
  () => import("../components/Contact/ContactForm"),
  { fallback: <div>loading...</div>, ssr: true }
)

const BookDemo = loadable(
  () => import("../components/MdxShortCodes/BookDemo"),
  { fallback: <div>loading...</div>, ssr: true }
)

export const TextColors = {
  Primary: mkText({ color: "#005CB9" }),
  Secondary: mkText({ color: "#00A98F" }),
}

export const identity = ({ children: x }: { children: unknown }) => x

const shortcodes = {
  // New
  Content,
  Section_,
  Button,
  Text_,
  Float,
  CircleMenu,
  Boxes,
  Lists,
  SpeechBabble,
  ScrollX,
  MoreText,
  WidgetRightPicture,
  WidgetLeftPicture,
  WidgetCenterText,
  TouchpointIcons,
  FeatureList,
  WidgetRightElement,
  WidgetLeftElement,
  WidgetCards,
  WidgetLists,
  TerminalSmilies,
  PreviewBlog,
  WidgetCenterPicture,
  FeatureCategories,
  YouTubeVideo,
  WidgetCenterElement,
  Laptop,
  RotatingMenu,
  PreviewSolution,
  ScrollableGallery,
  EmployeeIcons,
  ScrollToId,
  Card_,
  SwipeableScrolling,
  DropdownGallery,

  // Old
  Slideshow,
  SliderItem,
  SliderItemContent,
  ProductHeader,
  AboutBody,
  LocalImage: Image,
  HoverShadow,
  GridText,
  GridTextContainer,
  Section,
  TouchpointDescription: identity,
  Question: identity,
  CollectorDescription: identity,
  Primary: TextColors.Primary,
  Secondary: TextColors.Secondary,
  ContactForm,
  SimpleSection,
  BookDemoForm,
  ButtonLink,
  XpressOn,
  Video,
  Card,
  Accordion,
  AccordionItem,
  Iframe,
}

export default function MDXLayout({ children }: { children: JSX.Element }) {
  return (
    <MDXProvider components={shortcodes as MDXComponents}>
      {children}
    </MDXProvider>
  )
}

export function PureMDXLayout({ children }: { children: JSX.Element }) {
  return (
    <MDXProvider
      components={{ ...shortcodes, AboutBody: identity } as MDXComponents}
    >
      {children}
    </MDXProvider>
  )
}
